import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/task-lists')({
    staticData: {
        modules: ['claim'],
    },
    component: TaskListsLayout,
});

function TaskListsLayout() {
    return (
        <PageController route={Route}>
            <div className="relative">
                <Outlet />
            </div>
        </PageController>
    );
}
